import React, { useState } from 'react';
import { Card, Typography, Button, Input, Space, Tree } from 'antd';
import { SearchOutlined, NodeIndexOutlined } from '@ant-design/icons';

const { Title } = Typography;

const UtxoGenealogy: React.FC = () => {
  const [searchText, setSearchText] = useState('');

  // 模拟UTXO族谱数据
  const treeData = [
    {
      title: 'UTXO-001 (100.00 PKT)',
      key: 'utxo-001',
      children: [
        {
          title: 'UTXO-002 (60.00 PKT)',
          key: 'utxo-002',
          children: [
            {
              title: 'UTXO-005 (30.00 PKT)',
              key: 'utxo-005',
            },
            {
              title: 'UTXO-006 (25.00 PKT)',
              key: 'utxo-006',
            },
          ],
        },
        {
          title: 'UTXO-003 (35.00 PKT)',
          key: 'utxo-003',
          children: [
            {
              title: 'UTXO-007 (20.00 PKT)',
              key: 'utxo-007',
            },
            {
              title: 'UTXO-008 (15.00 PKT)',
              key: 'utxo-008',
            },
          ],
        },
        {
          title: 'UTXO-004 (5.00 PKT)',
          key: 'utxo-004',
        },
      ],
    },
  ];

  const onSelect = (selectedKeys: React.Key[], info: any) => {
    console.log('Selected:', selectedKeys, info);
  };

  return (
    <div>
      <Title level={2}>UTXO族谱</Title>

      <Card style={{ marginBottom: 16 }}>
        <Space>
          <Input placeholder="搜索UTXO ID" prefix={<SearchOutlined />} value={searchText} onChange={(e) => setSearchText(e.target.value)} style={{ width: 300 }} />
          <Button type="primary" icon={<NodeIndexOutlined />}>
            生成族谱图
          </Button>
        </Space>
      </Card>

      <Card title="UTXO关系树">
        <div className="utxo-tree">
          <Tree showLine showIcon defaultExpandAll onSelect={onSelect} treeData={treeData} />
        </div>
      </Card>

      <Card title="族谱说明" style={{ marginTop: 16 }}>
        <p>• 这个树形结构展示了UTXO之间的父子关系</p>
        <p>• 父节点被分割为多个子节点</p>
        <p>• 点击节点可以查看详细信息</p>
        <p>• 绿色节点表示未花费的UTXO</p>
        <p>• 灰色节点表示已花费的UTXO</p>
      </Card>
    </div>
  );
};

export default UtxoGenealogy;
